/* eslint-disable no-console, no-undef */
import Glide from '../../vendors/glide.min';

let animateTimer = null;

const getActiveSlide = (slider) => {
  const activeBullet = slider.querySelector('.glide__bullet--active');
  const steps = activeBullet.getAttribute('data-glide-dir');
  return steps.substring(1);
};

const setActiveCaption = (slider, num) => {
  clearTimeout(animateTimer);
  const sliderUl = slider.querySelector('.glide__slides');
  const captionList = document.querySelectorAll(`.glide__caption[data-glide-slider="${sliderUl.id}"]`);
  [].map.call(captionList, (caption) => {
    const captionNum = caption.getAttribute('data-caption');
    if (captionNum === num) {
      caption.classList.add('glide__caption--active');
      animateTimer = setTimeout(() => {
        caption.classList.add('glide__caption--animate-in');
      }, 100);
    } else {
      caption.classList.remove('glide__caption--active');
      caption.classList.remove('glide__caption--animate-in');
    }
  });
};

const init = (options) => {
  const { onSlideClick, slider } = options;
  const useCaptions = slider.getAttribute('data-usecaptions') === 'true';
  // Add glide
  const glide = new Glide(slider, {
    autoplay: false,
    focusAt: 'center',
    gap: 0,
    perView: 1,
    startAt: 0,
    type: 'carousel',
  });
  glide.mount();
  if (useCaptions) {
    glide.on(['update', 'run.after'], (event) => {
      const { direction, steps } = event;
      const active = direction === '=' ? steps : getActiveSlide(slider);
      setActiveCaption(slider, active.toString());
    });
  }
  glide.on(['update', 'run'], () => {
    const activeVideoList = slider.querySelectorAll('.glide__slide--active .video-wrapper');
    setTimeout(() => {
      [].map.call(activeVideoList, (wrapper) => {
        const iframe = wrapper.innerHTML;
        wrapper.innerHTML = '';
        wrapper.innerHTML = iframe;
      });
    }, 500);
  });

  const updateSliderHeight = () => {
    const div = slider.querySelector('.glide__track');
    div.style.height = `${(div.offsetWidth * (9 / 16)) + 20}px`;
  };

  slider.addEventListener('click', (event) => {
    const parent = event.target.closest('.image-gallery-item');
    if (parent) {
      const item = parent.querySelector('button');
      if (onSlideClick) {
        onSlideClick(item);
      }
    }
  });

  window.addEventListener('resize', updateSliderHeight);
  updateSliderHeight();
};

const update = (options) => {
  const { slider } = options;
  console.log(slider);
};

export {
  init,
  update,
};
/* eslint-enable no-console, no-undef */
